import { queryOptions, useQuery } from '@tanstack/react-query';

import { webhooksApi } from '../api/webhooks-api';

import { webhookKeys } from './webhook-keys';

/** The event names the backend can send; changes only with a backend release. */
export function webhookEventsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: webhookKeys.events(storeId),
    queryFn: () => webhooksApi.events(storeId),
    staleTime: 60 * 60_000,
  });
}

export function useWebhookEvents(storeId: string) {
  return useQuery(webhookEventsQueryOptions(storeId));
}
